module.exports = __webpack_public_path__ + "static/media/skipthedisheslogo.6f783161.jpg";